import { Component, inject, OnInit } from '@angular/core';
import firebase from 'firebase/compat/app';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, LoginErrors } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  private _router: Router = inject(Router);
  private authService: AuthService = inject(AuthService);
  private _snackBar: MatSnackBar = inject(MatSnackBar);
  loginForm: FormGroup;
  firebaseErrorMessage: string;
  user?: firebase.User;

  constructor() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
    });

    this.firebaseErrorMessage = '';
  }

  ngOnInit(): void {
    if (this.authService.user()) {
      this._router.navigate(['/events']);
    }
  }

  loginUser() {
    this.user = undefined;
    if (this.loginForm.invalid) return;

    this.authService
      .loginUser(this.loginForm.value.email, this.loginForm.value.password)
      .then((result) => {
        if (result?.isValid == false) {
          switch (result.message) {
            case LoginErrors.INVALID_CREDENTIAL:
              this.firebaseErrorMessage = 'Invalid email or password.';
              break;
            case LoginErrors.EMAIL_NOT_VALIDATED:
              this.firebaseErrorMessage = LoginErrors.EMAIL_NOT_VALIDATED;
              this.user = result.user;
              break;
            default:
              this.firebaseErrorMessage = result.message;
              break;
          }
          console.error(result.message);
        }
      });
  }

  loginWithGoogle() {
    this.authService.GoogleAuth().then((result) => {
      if (result?.isValid == false) {
        this.firebaseErrorMessage = result.message;
      }
    });
  }

  resendVerificationEmail() {
    if (this.user == undefined) return;
    this.user?.sendEmailVerification();
    this.user = undefined;
    this._snackBar.open('Verification email sent.', undefined, {
      duration: 5000,
    });
  }
}
